import produce from 'immer';
import {
    SET_LOGIN_PAGE_LOGO,
    SET_IDENTITY_PROVIDERS,
    SET_STANDARD_LOGIN_ERROR,
    SET_SSO_LOGIN_ERROR,
    SET_ACTIVE_DIALOG,
} from '../../actions/actionTypes';

export const defaultState = {
    companyLogoUrl: '',
    identityProviders: [],
    standardLoginErrors: {},
    ssoLoginErrorMessage: '',
    activeDialog: '',
};

const login = produce((draft, action) => {
    switch (action?.type) {
        case SET_ACTIVE_DIALOG:
            draft.activeDialog = action.activeDialog;
            return draft;
        case SET_LOGIN_PAGE_LOGO:
            draft.companyLogoUrl = action.url;
            return draft;
        case SET_IDENTITY_PROVIDERS:
            draft.identityProviders = action.identityProviders;
            return draft;
        case SET_STANDARD_LOGIN_ERROR:
            draft.standardLoginErrors = action.loginErrors;
            return draft;
        case SET_SSO_LOGIN_ERROR:
            draft.ssoLoginErrorMessage = action.loginErrors;
            return draft;
        default:
            return draft;
    }
}, defaultState);

export default login;
